/**
 * GET /lessons/club/:clubId/available — guest-browsable (`optionalAuth`).
 *
 * Thin pass-through: returns the envelope unchanged, never
 * `throw new Error(result.message)` (docs/conventions/internalapi-envelope.md).
 * Tenant and club headers come from `appRuntime` via apiClient.
 */

import { apiClient } from '~/lib/apiClient';
import type { ApiResult } from '~/lib/apiClient/types';
import type { ListLessonsPayload } from '../types';

export function listLessons(ctx: { clubId: number }): Promise<ApiResult<ListLessonsPayload>> {
  if (!ctx.clubId) throw new Error('clubId is required');
  return apiClient.get<ListLessonsPayload>(`/lessons/club/${ctx.clubId}/available`);
}
